var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate, useToastService } from '@lucidlink/uicore';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
export const useUpdateGuestLinkName = ({ filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const { addToast } = useToastService();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationKey: GuestLinkKeyFactory.mutations({
            filespaceId,
            workspaceId,
        }),
        mutationFn: async (params) => plugFilespaceClient({
            action: (fsClient) => fsClient.guestLinksManagement().updateGuestLink(params),
            filespaceId,
            workspaceId,
        }),
        onMutate: async (params) => {
            const exactKey = GuestLinkKeyFactory.exact({
                workspaceId,
                filespaceId,
                linkId: params.guestLinkId,
            });
            await queryClient.cancelQueries({ queryKey: exactKey });
            const prevName = queryClient.getQueryData(exactKey)?.name;
            queryClient.setQueryData(exactKey, (old) => old && { ...old, name: params.name, isOptimistic: true });
            return { prevName };
        },
        onError: (_, params, onMutationResult) => {
            // Undo only the optimistic name so a concurrent mutation's
            // optimistic ACL state is left untouched.
            queryClient.setQueryData(GuestLinkKeyFactory.exact({
                workspaceId,
                filespaceId,
                linkId: params.guestLinkId,
            }), (old) => old && {
                ...old,
                name: onMutationResult?.prevName ?? old.name,
                isOptimistic: false,
            });
            addToast({
                'data-testid': 'update-guest-link-name-error',
                kind: 'negative',
                content: {
                    message: translate('Failed to update guest link name'),
                },
            });
        },
        onSettled: (_data, _error, params) => {
            const pendingMutations = queryClient.isMutating({
                mutationKey: GuestLinkKeyFactory.mutations({
                    filespaceId,
                    workspaceId,
                }),
            });
            const listRefetch = queryClient.refetchQueries({
                queryKey: GuestLinkKeyFactory.list({
                    filespaceId,
                    workspaceId,
                }),
            });
            // Refetching `exact` while a later guest-link mutation is pending
            // would wipe its optimistic ACL state; the last one refetches it.
            if (pendingMutations > 1) {
                return listRefetch;
            }
            return Promise.all([
                listRefetch,
                queryClient.refetchQueries({
                    queryKey: GuestLinkKeyFactory.exact({
                        workspaceId,
                        filespaceId,
                        linkId: params.guestLinkId,
                    }),
                }),
            ]);
        },
        networkMode: 'always',
    });
    return mutation;
};
_react_refresh_temp_1(useUpdateGuestLinkName, "KrM3mhTkTlZAjWS6DCmlJKC0EYA=", false, () => [usePlugFilespaceClient, useToastService, useQueryClient, useMutation]);
